// EULA acceptance tracking.
// ==========================
// Tracks per-user EULA acceptance in localStorage, keyed by user id and the
// agreement version they accepted. Bumping EULA_VERSION re-prompts every user,
// even ones already signed in, without needing a backend round-trip.
//
// Keep EULA_VERSION in sync with the "Effective Date"/content of
// public/eula.md — bump it whenever the agreement materially changes.

export const EULA_VERSION = '2026-07-22';

const STORAGE_KEY = 'eula_acceptances';

function readMap() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch (e) {
    return {};
  }
}

export function hasAcceptedEula(userId) {
  if (userId == null) return false;
  const record = readMap()[String(userId)];
  return !!record && record.version === EULA_VERSION;
}

export function acceptEula(userId) {
  if (userId == null) return;
  try {
    const map = readMap();
    map[String(userId)] = { version: EULA_VERSION, acceptedAt: new Date().toISOString() };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  } catch (e) {
    /* ignore: a full/blocked localStorage just means we re-prompt next load */
  }
}
